import React from 'react'

export const indianaSetupVars = {
  siteId: 'indiana',
  pathPrefix: '/in',
  menuHeader: "Discover Indiana's Solution for:",
  appUrl: 'https://in.headed2.com',
  logoImg: '/images/assets/indiana/horizontal/dark.svg',
  headerTitle: `The Indiana CareerZone is a system designed for Indiana`
}
